/* eslint react-hooks/exhaustive-deps: 0 */ // --> OFF

// TODO: Find the possibility to put all this scroll listener into a hook.

import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '~/components';
import { ThemeContext } from '~/contexts';
import { info } from '~/utils';
import Demo from './Demo';
import { intersectionObserverInit } from './intersectionObservedIDs';

const DemoWrapper: React.FC = () => {
  const {
    theme: { colors },
  } = useContext(ThemeContext);
  const [isShowing, setIsShowing] = useState(false);

  const handleEventCallback = (e: IntersectionObserverEntry[]) => {
    setIsShowing(e[0].isIntersecting);
  };

  const initializeObserver = (): IntersectionObserver => {
    const observer = new IntersectionObserver(
      handleEventCallback,
      intersectionObserverInit,
    );

    const element = window.document.getElementById('subtitle');

    if (element) observer.observe(element);

    return observer;
  };

  const clearObserver = (observer?: IntersectionObserver) => {
    if (observer) observer.disconnect();
  };

  useEffect(() => {
    const observer = initializeObserver();

    info(
      <Typography typographyProps={{ style: { color: colors.text?.main } }}>
        This is the demo version project. All links are pointing to root.
      </Typography>,
    );

    return () => {
      clearObserver(observer);
    };
  }, []);

  return <Demo isShowing={isShowing} />;
};

export default DemoWrapper;
